import { Injectable } from '@angular/core';
import { ExternalMetricTypesService } from '../services/external-metric-types-service';
import { AdsMetricTypeNames, ExternalMetricType } from '../types/external-metrics.types';
import { LinkedInDataService } from './linkedin-data.service';

@Injectable({
  providedIn: 'root'
})
export class LinkedinMetricTypesService extends ExternalMetricTypesService {
  externalMetricTypes = [
    {
      type: ExternalMetricType.int,
      name: AdsMetricTypeNames.IMPRESSIONS,
      label: 'Impressions',
      description: 'How often your ads were shown'
    },
    {
      type: ExternalMetricType.int,
      name: AdsMetricTypeNames.CLICKS,
      label: 'Clicks',
      description: 'Actions on your ads'
    },
    {
      type: ExternalMetricType.int,
      name: AdsMetricTypeNames.CONVERSIONS,
      label: 'Conversions',
      description: 'Actions on your website from ads'
    },
    {
      type: ExternalMetricType.int,
      name: AdsMetricTypeNames.LEADS,
      label: 'Leads',
      description: 'People who has expressed interest in your product or service'
    },
  ];
  defaultMapping = {
    [AdsMetricTypeNames.IMPRESSIONS]: 'Impressions',
    [AdsMetricTypeNames.CLICKS]: 'Clicks',
    [AdsMetricTypeNames.CONVERSIONS]: 'Conversions',
    [AdsMetricTypeNames.LEADS]: 'Leads',
  };

  constructor(
    private readonly linkedInDataService: LinkedInDataService
  ) {
    super(linkedInDataService);
  }
}
